import utils from "@modules/common/utils"

export const synchronizeStores = (f: Function) => setTimeout(async () => {
//  await utils.sleep(0) // To avoid warnings in chrome
  f()
}, 0)



// WEBPACK FOOTER //
// ./src/stores/SynchronizeStores.ts